import { listUsers } from './index';

import { usersRouteStore } from '../domain/store';

export default (number) => {
  usersRouteStore.setValue('currentPage', number);
  return listUsers();
};
